export default __webpack_public_path__ + "locales/tr/InfoPanel.json?hash=60cff21244861fa87c95e8aca8cf5b74";